import { AuthenticatedHttpService } from 'http/httpService'
import { GlobalSearchError, SearchRequest, SearchResponse } from './schema'
import { t } from 'translations'

export class GlobalSearchService {
    constructor(private httpService: AuthenticatedHttpService, private backofficeEndpoint: string) {}

    async search(accountSlug: string, request: SearchRequest, signal?: AbortSignal): Promise<SearchResponse> {
        const response = await this.httpService.fetch(
            `${this.backofficeEndpoint}api/v1/accounts/${accountSlug}/search/`,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(request),
                signal,
            },
        )
        if (response.status === 400) {
            const body = await response.json().catch(() => null)
            throw new GlobalSearchError(
                t('globalSearch.errors.validation'),
                'validation_error',
                body?.filterErrors ?? body?.filter_errors,
            )
        }
        if (response.status === 403) {
            throw new GlobalSearchError(t('globalSearch.errors.noAccess'), 'no_access')
        }
        if (response.status === 404) {
            throw new GlobalSearchError(t('globalSearch.errors.accountNotFound'), 'account_not_found')
        }
        if (!response.ok) {
            throw new GlobalSearchError(`Global search failed: ${response.status}`, 'unknown')
        }
        const body = await response.json()
        return {
            groups: body.groups ?? {},
            filterErrors: body.filterErrors ?? body.filter_errors,
        }
    }
}
